import BodyText from 'LuxKit/Typography/BodyText'
import { rem } from 'polished'
import type { PropsWithChildren } from 'react'
import styled from 'styled-components'

// Matches the carousel's own image-counter overlay style (LuxKit/Carousel/ImageCarousel.tsx).
const Badge = styled.div`
  display: inline-flex;
  padding: ${rem(4)} ${rem(8)};
  border-radius: ${p => p.theme.borderRadius.S};
  background-color: ${p => p.theme.palette.neutral.surface.darkBackground};
  background-color: color-mix(in srgb, ${p => p.theme.palette.neutral.surface.darkBackground}, transparent 20%);
`

const BadgeText = styled(BodyText)`
  color: ${p => p.theme.palette.neutral.surface.darkContrast};
`

function _SponsoredTileBadge({ children }: PropsWithChildren) {
  return <Badge className={_SponsoredTileBadge.name}>
    <BadgeText variant="small">
      {children}
    </BadgeText>
  </Badge>
}

export default _SponsoredTileBadge
